import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import LogoutCircleRLineIcon from "remixicon-react/LogoutCircleRLineIcon";
import LoginCircleLineIcon from "remixicon-react/LoginCircleLineIcon";
import DrawerContainer from "containers/drawer/drawer";
import cls from "./appDrawer.module.scss";
import { ThemeContext } from "contexts/theme/theme.context";
import { profileDropdownLinks } from "components/profileDropdown/profileDropdownLinks";
import { useAuth } from "contexts/auth/auth.context";
import Link from "next/link";
import dynamic from "next/dynamic";
import Wallet3LineIcon from "remixicon-react/Wallet3LineIcon";
import Price from "components/price/price";
import { getNearestFloor } from "utils/getNearestFloor";

const ProfileCard = dynamic(() => import("components/profileCard/profileCard"));

type Props = {
  open: boolean;
  handleClose: () => void;
};

export default function AppDrawer({ open, handleClose }: Props) {
  const { t } = useTranslation();
  const { direction } = useContext(ThemeContext);
  const { user, isAuthenticated, logout, openAuthModal, openWalletHistory } =
    useAuth();

  const actualLinks = !isAuthenticated
    ? profileDropdownLinks.filter((item) => !item.requiredAuth)
    : profileDropdownLinks;

  const handleSignInAndSingOut = () => {
    if (isAuthenticated) {
      logout();
      handleClose();
    } else {
      openAuthModal();
      handleClose();
    }
  };

  return (
    <DrawerContainer
      anchor={direction === "rtl" ? "right" : "left"}
      open={open}
      onClose={handleClose}
    >
      <div className={cls.wrapper}>
        {isAuthenticated && (
          <ProfileCard data={user} handleClose={handleClose} />
        )}
        <div className={cls.links}>
          {isAuthenticated && (
            <>
              <button
                type="button"
                className={cls.link}
                key="wallet"
                onClick={() => {
                  handleClose();
                  openWalletHistory();
                }}
              >
                <Wallet3LineIcon size={24} />
                <div className={cls.text}>
                  {t("wallet")}:{" "}
                  <span>
                    <Price number={getNearestFloor(user?.wallet?.price)} />
                  </span>
                </div>
              </button>
              <div className={cls.horizontalLine} />
            </>
          )}
          {actualLinks.map((item, index) => (
            <Fragment key={item.href}>
              {index !== 0 && <div className={cls.horizontalLine} />}
              <Link href={item.href} key={item.href} onClick={handleClose}>
                <div className={cls.link}>
                  {item.icon}
                  <span>{t(item.label)}</span>
                </div>
              </Link>
            </Fragment>
          ))}
          <div className={cls.horizontalLine} />
          <button
            type="button"
            className={cls.link}
            onClick={handleSignInAndSingOut}
          >
            {isAuthenticated ? (
              <>
                <LogoutCircleRLineIcon />
                <span>{t("log.out")}</span>
              </>
            ) : (
              <>
                <LoginCircleLineIcon />
                <span>{t("login")}</span>
              </>
            )}
          </button>
        </div>
      </div>
    </DrawerContainer>
  );
}
